import { IoIosAdd } from 'react-icons/io';

import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';

export const Container = styled.div`
  display: flex;
  padding-bottom: 16px;
`;

export const Left = styled.div`
  flex: 1;
`;

export const Title = styled.h1`
  font-weight: 600;
  font-size: 16px;
  color: ${ColorPalette.HEX.CharlestonGreen};
  line-height: 1.6em;
`;

export const Subtitle = styled.h2`
  font-size: 12px;
  font-weight: normal;
  color: ${ColorPalette.HEX.DimGray2};
  line-height: 1.4em;
`;

export const Right = styled.div`
  display: flex;
  align-items: center;
`;

export const CloseButton = styled.button`
  display: flex;
  cursor: pointer;
  background: none;
`;

export const CloseIcon = styled(IoIosAdd)`
  font-size: 30px;
  transform: rotate(45deg);
`;
